import React from "react";
import { BookOpen, ExternalLink, Info } from "lucide-react";
import { useLang } from "../../i18n";
import { sources, sourceTopics } from "../../data/safety";

export default function Sources() {
  const { t, lang } = useLang();
  return (
    <div className="mt-12 space-y-6">
      <div className="grid-panel rounded-lg p-5">
        <div className="flex items-center gap-2 text-sonne"><BookOpen size={16} /><span className="instrument-label">{t.safety.sourcesTitle}</span></div>

        <div className="mt-5 space-y-7" data-testid="sources-list">
          {sourceTopics.map((topic) => {
            const list = sources.filter((s) => s.topic === topic.id);
            if (list.length === 0) return null;
            return (
              <div key={topic.id}>
                <p className="instrument-label text-bronze-soft mb-3">{lang === "de" ? topic.de : topic.en}</p>
                <ul className="space-y-4">
                  {list.map((s) => (
                    <li key={s.doi || s.pmid || s.url} className="border-l-2 border-bronze/40 pl-3">
                      <p className="font-mono text-xs leading-relaxed text-wachs-dim">
                        <span className="text-wachs">{s.authors}</span> ({s.year}). {s.title}. <span className="italic">{s.journal}</span>.
                        {s.doi && <> DOI: <span className="text-bronze-soft">{s.doi}</span>.</>}
                      </p>
                      <p className="mt-1.5 text-xs leading-relaxed text-wachs-dim">{lang === "de" ? s.findingDe : s.findingEn}</p>
                      <div className="mt-1.5 flex items-center gap-3">
                        {s.pmid && (
                          <a href={`https://pubmed.ncbi.nlm.nih.gov/${s.pmid}/`} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 font-mono text-[11px] text-sonne hover:underline">
                            PubMed · PMID {s.pmid} <ExternalLink size={11} />
                          </a>
                        )}
                        <a href={s.url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 font-mono text-[11px] text-sonne hover:underline">
                          {s.doi ? "DOI" : "Link"} <ExternalLink size={11} />
                        </a>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>

      <div className="rounded-lg border border-bronze/25 bg-tiefsee/40 p-5 flex items-start gap-3" data-testid="safety-disclaimer">
        <Info size={16} className="text-bronze-soft shrink-0 mt-0.5" />
        <div>
          <p className="instrument-label text-bronze-soft">{t.safety.disclaimerTitle}</p>
          <p className="mt-1 font-mono text-xs leading-relaxed text-wachs-dim">{t.footer.disclaimer}</p>
        </div>
      </div>
    </div>
  );
}
